import { render } from "./Cart_Details.vue?vue&type=template&id=5f529c12&scoped=true"
import script from "./Cart_Details.vue?vue&type=script&lang=js"
export * from "./Cart_Details.vue?vue&type=script&lang=js"

import "./Cart_Details.vue?vue&type=style&index=0&id=5f529c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f529c12"]])

export default __exports__